import type { StatusTone } from '@/components/ui/kit';
import type { AgentRunStatus } from './api';
import runtimeCopy from '@/i18n/ns/workspace-knowledge-runtime';

// A run's state in one word, the same on its Runs row and its run chat's card.
export const runStatusLabel = (
  status: AgentRunStatus,
  copy: Readonly<Record<keyof typeof runtimeCopy.en, string>> = runtimeCopy.en,
) =>
  ({
    queued: copy.statusQueued,
    running: copy.statusRunning,
    awaiting_approval: copy.statusApproval,
    completed: copy.statusDone,
    failed: copy.statusFailed,
    cancelled: copy.statusCancelled,
  })[status];

const TONES: Partial<Record<AgentRunStatus, StatusTone>> = {
  completed: 'success',
  failed: 'danger',
  running: 'live',
  awaiting_approval: 'warning',
};

export const runStatusTone = (status: AgentRunStatus): StatusTone => TONES[status] ?? 'neutral';
